import { BaseDataModel } from "@domain/CRM/BaseDataModel";

export class Region extends BaseDataModel {
	name!: string;
	branchIds?: string[];
	companyIds?: string[];
}
